angular.module('unergie.main')
.controller('irrecoverabilityDeclarationCtrl', ($scope, $state, ApiUser, DataAccess, BoFeaturesService, AlertManager, TableGeneratorService, NgTableParams, ErrorCatcher) => {
    $scope.irrecoverabilityDeclaration = {
        refreshing: false,
        show: {},
        columns: {
            id: { label: 'ID', mode: 'search_operator', mandatory: true },
            status: { label: 'Statut', mode: 'search_wildcard' },
            xlsx_path: { label: 'Excel', mode: 'search_wildcard' },
            declaration_date: { label: 'Date d\'éxécution', mode: 'search_date' },
            declaration_year: { label: 'Année de declaration', mode: 'search_operator' },
            quarter_number: { label: 'Trimestre', mode: 'search_operator' },
            preparation_result: { label: 'Prep result', mode: 'hidden' },
            error: { label: 'Erreur', mode: 'hidden' },
        },
    }

    $scope.declarationField = {
        declaration_year: { label: 'Année à declarer', type: 'text', required: true, pattern: /^\d{4}$/ },
        quarter_number: { label: 'Trimestre à declarer', type: 'text', required: true, pattern: /^[1-4]{1}$/ },
        force: { label: 'Forcer', type: 'checkbox' },
    }

    $scope.declarationPayload = {
        declaration_year: null,
        quarter_number: null,
        force: false,
    }

    $scope.createDeclaration = () => {
        $scope.creating = true
        return ApiUser.createIrrecoverabilityDeclaration(_.pick($scope.declarationPayload, ['force']), _.pick($scope.declarationPayload, ['declaration_year', 'quarter_number'])).$promise
        .then((result) => {
            AlertManager.success('Déclaration créée')
            $scope.refresh()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.creating = false
        })
    }

    $scope.fetchIrrecoverabilityDeclarationPayments = (declaration) => {
        declaration.fetching = true
        return DataAccess.fetchIrrecoverabilityDeclarationPayments({ id: declaration.id }).$promise
        .then((results) => {
            declaration.payments = results
            declaration.nbIncludedPayments = _.filter(results, (res) => res.included).length
            declaration.totalPlus = _.sumBy(_.filter(results, (res) => res.included && res.amount > 0),
                (res) => (_.get(res, 'additional_data.toDeclare.distribution', 0) + (_.get(res, 'additional_data.toDeclare.managementFee', 0) - _.get(res, 'additional_data.pescribedAmount', 0))))
            declaration.totalMinus = -_.sumBy(_.filter(results, (res) => res.included && res.amount < 0),
                (res) => _.get(res, 'additional_data.toDeclare.distribution', 0) + (_.get(res, 'additional_data.toDeclare.managementFee', 0) - _.get(res, 'additional_data.pescribedAmount', 0)))
            declaration.total = declaration.totalPlus - declaration.totalMinus
            declaration.paymentsTable = new NgTableParams({ count: 30 }, { counts: [], dataset: results })
        })
        .catch(ErrorCatcher)
        .finally(() => {
            declaration.fetching = false
        })
    }

    $scope.unlinkPaymentFromDeclaration = (declaration, payment) => {
        payment.unlinking = true
        return DataAccess.unlinkPaymentFromDeclaration({ id_declaration: declaration.id, id_payment: payment.id }).$promise
        .then((results) => {
            AlertManager.success('CIR retiré, pensez à régénérer le Excel avec le bouton "recycler" VERT (une fois que vous avez terminé avec vos modifications)!')
            $scope.fetchIrrecoverabilityDeclarationPayments(declaration)
        })
        .catch(ErrorCatcher)
        .finally(() => {
            payment.unlinking = false
        })
    }

    $scope.linkPaymentFromDeclaration = (declaration, payment) => {
        payment.linking = true
        return DataAccess.linkPaymentFromDeclaration({ id_declaration: declaration.id, id_payment: payment.id }, {}).$promise
        .then((results) => {
            AlertManager.success('CIR rajouté, pensez à régénérer le Excel avec le bouton "recycler" VERT (une fois que vous avez terminé avec vos modifications)!')
            $scope.fetchIrrecoverabilityDeclarationPayments(declaration)
        })
        .catch(ErrorCatcher)
        .finally(() => {
            payment.linking = false
        })
    }

    $scope.prescriptionFields = {
        amount: { label: 'Montant préscrit', type: 'number', required: true },
    }

    $scope.prescriptionTemplate = {}

    $scope.updatePrescriptionTemplate = (payment) => {
        $scope.prescriptionTemplate.amount = payment.additional_data.pescribedAmount || 0
    }

    $scope.addPrescribedAmountOnCirPayment = (declaration, payment) => {
        payment.prescribing = true
        return DataAccess.addPrescribedAmountOnCirPayment({ id_payment: payment.id }, $scope.prescriptionTemplate).$promise
        .then((results) => {
            AlertManager.success('Montant préscrit rajouté, pensez à régénérer le Excel avec le bouton "recycler" VERT (une fois que vous avez terminé avec vos modifications)!')
            $scope.fetchIrrecoverabilityDeclarationPayments(declaration)
        })
        .catch(ErrorCatcher)
        .finally(() => {
            payment.prescribing = false
        })
    }

    $scope.paymentProcessing = (payment) => {
        return payment.prescribing || payment.unlinking || payment.linking
    }

    $scope.regenIrrecoverabilityDeclarationFields = {
        warning: {
            type: 'label',
            label: `<span class="red"><span class="fa fa-warning"></span> Attention cela va récupérer tous les paiements que vous auriez potentiellement retirés, `
                + `pour régénérer uniquement le excel, utilisez le bouton recycler à côté du bouton de téléchargement.</span>`,
        },
    }

    $scope.regenIrrecoverabilityDeclaration = (declaration) => {
        declaration.regenerating = true
        return ApiUser.regenIrrecoverabilityDeclaration({ id: declaration.id }, {}).$promise
        .then((result) => {
            AlertManager.success('Déclaration régénérée')
            $scope.refresh()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            declaration.regenerating = false
        })
    }

    $scope.changeStatusFields = {
        label: {
            type: 'label',
            label: (template) => {
                switch (template.status) {
                    case 'GENERATED':
                        return `Permet la régénération.`
                    case 'VALIDATED':
                        return `La déclaration a été validée par Enedis, <span class="red">plus de régéneration possible + la déclaration sera envoyée à Odoo.</span>`
                    case 'TRANSMITTED':
                        return `La déclaration est transmise à Enedis, <span class="red">plus de régéneration possible.</span>`
                    default:
                        return ''
                }
            },
        },
        status: {
            label: 'Nouveau statut',
            type: 'select',
            enum: [
                { label: 'GENERATED', value: 'GENERATED' },
                { label: 'TRANSMITTED', value: 'TRANSMITTED' },
                { label: 'VALIDATED', value: 'VALIDATED' },
            ],
        },
    }

    $scope.changeStatusTemplate = {
        status: null,
    }

    $scope.updateChangeStatusTemplate = (declaration) => {
        $scope.changeStatusTemplate.status = declaration.status
    }

    $scope.updateIrrecoverabilityDeclaration = (declaration) => {
        declaration.changingStatus = true
        return DataAccess.updateIrrecoverabilityDeclaration({ id: declaration.id }, _.pick($scope.changeStatusTemplate, ['status'])).$promise
        .then((results) => {
            AlertManager.success('Statut modifié')
            $scope.refresh()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            declaration.changingStatus = false
        })
    }

    $scope.toggleExpand = (declaration) => {
        declaration.expanded = !declaration.expanded
        if (!declaration.payments) {
            $scope.fetchIrrecoverabilityDeclarationPayments(declaration)
        }
    }

    $scope.inProcess = (declaration) => {
        return declaration.regenerating || declaration.changingStatus
    }

    $scope.refresh = () => {
        TableGeneratorService.getTable($scope.irrecoverabilityDeclaration, 'irrecoverability-declarations', null, null, { orderBy: 'declaration_date' })
    }


    $scope.refresh()
})
